import React from 'react';
import { FieldRequirementsTool } from './pages/FieldRequirementsTool';
export function App() {
  return <FieldRequirementsTool data-id="element-0" />;
}